<div class="h-full" *ngIf="commonService.practice">
  <dentr-stockings></dentr-stockings>
  <div class="relative z-0 mx-auto flex h-full max-w-screen-xl flex-1 flex-col justify-between px-16 pt-10 pb-4 focus:outline-none">
    <main>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
